import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { getEpikBoxesData } from '../../actions/EpikBoxes';
import {
  addEmailFieldChange,
  addNumberFieldChange,
  getCompanyNumbers,
  uploadFile,
} from '../../actions/Numbers';
import CompanyAutocomplete from '../CompanyAutocomplete';
import NumberTypeSelect from './NumberTypeSelect';
import { hiddenNumberCarrierOptions, numberCarrierOptions } from '../../utils/constants';
import Select from 'react-select';
import { getPermissionForComponent } from '../../utils/permissionsUtils';


class AddNumberBulk extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');
    this.state = {
      checkedBox: false,
      numDigits: 1,
      spoofType: 'same',
      epikBoxes: [],
      number: '',
      routeInfo: { route: '1804', gateway: '208.65.249.104:5080' },
      company: '',
      trunks: this.props.trunks.trunkGroupList,
      tdmRoute: this.props.tdmRoutes[0],
      numberCarrierChangeAccess: false,
    };
  }

  componentDidMount() {
    const { onChange, user } = this.props;
    onChange('routeInfo', this.state.routeInfo);
    onChange('tdmRoute', this.state.tdmRoute);
    this.props.addNumberFieldChange('carrier', numberCarrierOptions[0]);
    const numberCarrierChangeAccessPermission = getPermissionForComponent('numberCarrierChangeAccess',user.permissionsGroup);
    this.setState({ numberCarrierChangeAccess: numberCarrierChangeAccessPermission })
  }

  onAddedCompanyChange = async ({ name, value, suggestion }) => {
    const { onChange } = this.props;
    if (suggestion) {
      onChange('company', suggestion._id);
    }
  };

  onNumberTypeSelect = numberType => {
    this.props.addNumberFieldChange('type', numberType?.value);
  };

  onAddedNumberChange = ev => {
    const { value } = ev.currentTarget;
    this.setState({ number: value });
    const { onChange } = this.props;
    onChange('number', value);
  };

  onHandleRoute = ev => {
    const { onChange } = this.props;
    if (ev.trunk) {
      this.setState({ trunk: ev.trunk });
      onChange('trunk', ev.trunk);
    } else if (ev.tdmRoute) {
      this.setState({ tdmRoute: ev.tdmRoute });
      onChange('tdmRoute', ev.tdmRoute);
    } else {
      this.setState({ routeInfo: ev });
      onChange('routeInfo', ev);
    }
  };
  getLabel = carrier => {
    if (carrier == 'inteliquent') return 'Trunk';
    return 'Route';
  };
  render() {
    const { companies, gateways, carrier, tdmRoutes, user } = this.props;
    const { number } = this.state;
    return (
      <div className="container numbers-container">
        <div className="row">
          <div className="text-left" style={{ width: '100%' }}>
            <FormGroup row>
              <Col sm={6}>
                <Label for="number" sm={12}>
                  Number
                </Label>
                <Input
                  required
                  type="textarea"
                  name="number"
                  value={number}
                  onChange={this.onAddedNumberChange}
                />
              </Col>
              <Col sm={3}>
                <Label for="type" sm={12}>
                  Type
                </Label>
                <NumberTypeSelect
                  disabledAdmin
                  required
                  name="type"
                  onTypeSelect={this.onNumberTypeSelect}
                  selectedType={'unassigned'}
                  comingFrom="number"
                />
              </Col>
              { this.state.numberCarrierChangeAccess && (
                <Col sm={3}>
                <Label for="type" sm={12}>
                  Carrier Type
                </Label>
                <Select
                  options={numberCarrierOptions}
                  onChange={option => this.props.addNumberFieldChange('carrier', option)}
                  isOptionDisabled={option =>
                    hiddenNumberCarrierOptions(option.value, this.state.numberCarrierChangeAccess)
                  }
                  isDisabled={this.state.numberCarrierChangeAccess === 'read'}
                  value={carrier}
                  form="carrier"
                />
              </Col>
              )}
            </FormGroup>

            <FormGroup row>
              <Col sm={6}>
                <Label for="company" sm={12}>
                  Company
                </Label>
                <CompanyAutocomplete
                  placeholder="Filter Company..."
                  companies={companies.docs || []}
                  onChange={this.onAddedCompanyChange}
                />
              </Col>
            </FormGroup>
       
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  company: state.UIState.numbers.addNumber.company,
  companies: state.AppState.companies,
  type: state.UIState.numbers.addNumber.type,
  carrier: state.UIState.numbers.addNumber.carrier,
  email: state.UIState.numbers.filterNumbersByCompany.number,
  emails: state.UIState.numbers.addNumberFieldChange,
  gateways: state.AppState.provisioning.gateways,
  trunks: state.AppState.provisioning.trunkGroupList,
  tdmRoutes: state.AppState.tdmRoutes,
});

const mapDispatchToProps = dispatch => ({
  addNumberFieldChange: (name, value) => dispatch(addNumberFieldChange(name, value)),
  addEmailFieldChange: emails => dispatch(addEmailFieldChange(emails)),
  getCompanyNumbers: (token, id, uid) => dispatch(getCompanyNumbers(token, id, uid)),
  uploadFile: (token, id, files) => dispatch(uploadFile(token, id, files)),
  getEpikBoxesData: (token, companyId, online, unmonitored, disablePaginate) =>
    dispatch(getEpikBoxesData(token, companyId, online, unmonitored, disablePaginate)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddNumberBulk);
